<template lang="pug">
div
  div(slot="body" v-if="cadastroOriginal.tipoReurbIndividual")
    el-row(:span="24")
      el-col(:span="12")
        app-display(
          id="TIPO_REURB",
          label="Tipo de Reurb:",
          :content="formataTipoReurb(cadastroOriginal.tipoReurbIndividual)"
        )
      el-col(:span="12")
        app-display(
          id="TIPO_REQUERENTE",
          label="Tipo requerente:",
          :content="formatarTexto(cadastroOriginal.tipoRequerente || cadastroOriginal.interessado.pessoa.tipo)"
        )

    div(v-if="isTipoRequerentePj", slot="body")
      app-divider(label="Dados Requerente")
      el-row(:span="24")
        el-col(:span="12")
          app-display(
            id="CNPJ",
            label="CNPJ:",
            :content="getData.cnpj"
          )
        el-col(:span="12")
          app-display(
            id="RAZAO_SOCIAL",
            label="Razão social:",
            :content="getData.razaoSocial"
          )
  div(v-if="!cadastroOriginal")
    el-col
      app-display(
        :content="'Não foi informado nenhum dado durante o cadastro.'"
      )
</template>

<script>
import AppDisplayColapse from '@/components/AppDisplayColapse'
import AppDivider from '@/components/AppDivider.vue'
import AppDisplay from '@/components/AppDisplay'

export default {
  props: {
    cadastroOriginal: {
      type: Object,
      required: true
    }
  },
  components: {
    AppDisplayColapse,
    AppDivider,
    AppDisplay
  },
  computed: {
    isTipoRequerentePj () {
      const tipo = this.cadastroOriginal.interessado?.pessoa?.tipo

      return ['PESSOA_JURIDICA', 'PJ'].includes(this.cadastroOriginal.tipoRequerente || tipo)
    },
    getData () {
      const isPjNovo = !!this.cadastroOriginal.interessado?.pessoa?.pessoaJuridica

      const cnpj = isPjNovo ? this.cadastroOriginal.interessado.pessoa.pessoaJuridica.cnpj : this.cadastroOriginal.cnpjRequerente
      const razaoSocial = isPjNovo ? this.cadastroOriginal.interessado.pessoa.pessoaJuridica.razaoSocial : this.cadastroOriginal.razaoSocialRequerente

      return {
        cnpj,
        razaoSocial
      }
    }
  },
  methods: {
    formatarTexto (texto) {
      if (!texto) return '-'

      if (['PESSOA_FISICA', 'PF'].includes(texto)) {
        return 'Pessoa física'
      } else if (['PESSOA_JURIDICA', 'PJ'].includes(texto)) {
        return 'Pessoa jurídica'
      }
      return '-'
    },
    formataTipoReurb (tipo) {
      if (['REURB_S', 'REURB_E', 'REURB S', 'REURB E'].includes(tipo)) {
        return tipo.replace('_', ' ')
      }
      return '-'
    }
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/informacoesCadastro/ma/InformacoesComplementares.vue